import React,{useEffect,useState} from "react";
import { useParams } from "react-router";
import Navbar from './Navbar';
import { useTranslation } from 'react-i18next';
import constants from "../../common/constants";
import {getVideo} from '../../services/api';
import { useLocation } from 'react-router-dom';

const Video = (props) =>{
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const {id} = useParams();
    const operator = localStorage.getItem('currentOperator');
    const [video,setVideo] = useState();
     // Use useLocation to get access to location object
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');
    const lang = i18n.language.toUpperCase();
    
    useEffect(()=>{
            getVideo(code,id)
            .then((response)=>{
            console.log(response.data.video);
            setVideo(response.data.video);
            })
            .catch((error)=>{console.error('Error fetching video:', error);})
            .finally(()=>{console.error('fetching video is done');})

    },[code,id]);

    return(
        <div className='bg-video pb-5'>
            <Navbar user_id={props.user_id} setUserId={props.setUserId} hostname={props.hostname} isVideo={true}/>
            {video &&(
                    <div className="video container text-center pt-3" style={{marginBottom:"200px"}}>
                        <h1 className={`text-light text-capitalize  ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{video.category_name[lang]}</h1>
                        <h4 className={`text-light text-capitalize pt-2  ${isArabic ? 'notokufi-black' : 'avenir-black'}`}>{video.translations[lang].title}</h4>
                        <div className="video-container text-center" style={{paddingTop:"50px"}}>
                            {video.video_url && (
                                <>
                                    <video width="60%" height="60%" controls controlsList="nodownload" preload="metadata" allow="autoplay; fullscreen; picture-in-picture" crossOrigin="anonymous">
                                        <source type="video/mp4" src={video.video_url} />
                                        {Object.keys(video.translations).map((key) => {
                                            const translation = video.translations[key];
                                            return (
                                                translation.video_srt && (
                                                    <track  key={key} id="tracks" label={translation.language} kind="subtitles" srcLang={key.toLowerCase()} src={translation.video_srt}  {...(key === lang ? { default: true } : {})}/>
                                                )
                                            );
                                         })}
                                    </video>   
                                </>
                             )}
                             {!video.video_url && (
                               <h2 className={`thank-you pt-4  ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('video.video-not-found')}</h2>
                             )}
                            <div className="w-50 text-center mx-auto">
                              <p className={`pt-4 text-light  ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{fontSize:"1em"}}>{video.translations[lang].description}</p>
                           </div>
                        </div>
                    </div>
            )}

        </div>
    );
};

export default Video;